import { DeveloperTemplate, WorkflowTemplatePanel } from "../../../../templates";
import { Column, Row, UserHeader } from "../../../../widget";
import { RelatedProjectsPanel, WorkflowDataCards } from "./components";
import { useWorkflowTemplates } from "./useWorkflowTemplates";

const WorkflowTemplates = (): JSX.Element => {
  const {
    onPrevious,
    onNext,
    hasNext,
    hasPrevious,
    workflowTemplates,
    isLoadingWorkflowTemplates,
    relatedProjectWorkflowTemplateUuid,

    projectTypeFilterUuid,
    setProjectTypeFilterUuid,

    showCreateWorkflowTemplatePanel,
    setShowCreateWorkflowTemplatePanel,
    isExpiredFilter,
    setIsExpiredFilter,

    setRefreshWorkflowTemplates,

    projectTypesSelectData,
  } = useWorkflowTemplates();

  return (
    <DeveloperTemplate activeElement="Templates">
      <Row spacingV="ml">
        <Column span={12}>
          <UserHeader />
        </Column>
      </Row>
      <Row spacingV="ml">
        <Column span={12}>
          <div className="HeaderContainer">
            <h1>Workflows</h1>
          </div>
        </Column>
      </Row>
      <Row spacingV="ll">
        <Column span={12}>
          <WorkflowDataCards
            header="Available workflow templates"
            data={workflowTemplates}
            setShowCreateWorkflowTemplatePanel={setShowCreateWorkflowTemplatePanel}
            projectTypesSelectData={projectTypesSelectData}
            projectTypeFilterUuid={projectTypeFilterUuid}
            setProjectTypeFilterUuid={setProjectTypeFilterUuid}
            onPrevious={onPrevious}
            onNext={onNext}
            hasNext={hasNext}
            hasPrevious={hasPrevious}
            isLoadingWorkflowTemplates={isLoadingWorkflowTemplates}
            workflowTemplateUuid={relatedProjectWorkflowTemplateUuid}
            isExpiredFilter={isExpiredFilter}
            setIsExpiredFilter={setIsExpiredFilter}
          />
        </Column>
      </Row>
      <Row spacingV="ml">
        <Column span={12}>
          <RelatedProjectsPanel workflowTemplateUuid={relatedProjectWorkflowTemplateUuid} />
        </Column>
      </Row>
      <WorkflowTemplatePanel
        workflowTemplateType="Project"
        projectTypesSelectData={projectTypesSelectData}
        show={showCreateWorkflowTemplatePanel}
        onClose={() => setShowCreateWorkflowTemplatePanel(false)}
        setRefresh={setRefreshWorkflowTemplates}
      />
    </DeveloperTemplate>
  );
};

export default WorkflowTemplates;
